new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement && formButton) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    const icon = formButton.querySelector('i');
                    const originalText = formButton.textContent;

                    formButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        navigator.clipboard.writeText(newValue).then(() => {

                            // altera texto mantendo o ícone
                            if (icon) {
                                formButton.innerHTML = 'Copiado!';
                            } else {
                                formButton.textContent = 'Copiado!';
                            }

                            // volta ao original após 2s
                            setTimeout(() => {
                                if (icon) {
                                    formButton.innerHTML = icon.outerHTML + ' ' + originalText.trim();
                                } else {
                                    formButton.textContent = originalText;
                                }
                            }, 2000);

                        }).catch(err => {
                            console.error('Erro ao copiar: ', err);
                        });
                    });
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {


    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1000,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner - DEFER to after first paint
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    // Defer slick initialization to after first paint for better LCP
    requestAnimationFrame(() => {
        initBannerHome(bannerHomeFull);
    });

    waitForElementToExist('.rotation-vitrine.first-rotation').then(element => {
      $('.rotation-vitrine.first-rotation #carrousel-product-list').slick({
          arrows: true,
          dots: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 700,

          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 2
                  }
              },
              {
                  breakpoint: 991,
                  settings: {
                      slidesToShow: 4,
                      arrows: true,
                      appendArrows: $(
                          '.rotation-vitrine.first-rotation ' +
                          '.vitrine-arrow .vitrine-arrows-1'
                      )
                  }
              }
          ]
      });

      $('.rotation-vitrine.first-rotation #carrousel-product-list2').slick({
          arrows: true,
          dots: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 700,

          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 2
                  }
              },
              {
                  breakpoint: 991,
                  settings: {
                      slidesToShow: 4,
                      arrows: true,
                      appendArrows: $(
                          '.rotation-vitrine.first-rotation ' +
                          '.vitrine-arrow .vitrine-arrows-2'
                      )
                  }
              }
          ]
      });

      if (element) {
          const rotationNames = element.querySelectorAll(
              '.vitrines-select .vitrines-select-name'
          );

          const initVitrine = Array.from(
              element.querySelectorAll(
                  '.vitrines-products .vitrines-products-item'
              )
          );

          const allLinks = element.querySelectorAll('.see-all');

          const carouselIds = [
              '.rotation-vitrine.first-rotation #carrousel-product-list',
              '.rotation-vitrine.first-rotation #carrousel-product-list2'
          ];

          const format = value => String(value).padStart(2, '0');

          function updateCount(index) {
              const $carousel = $(carouselIds[index]);

              if (!$carousel.hasClass('slick-initialized')) return;

              const slick = $carousel.slick('getSlick');

              $('.count-content .count-first')
                  .eq(index)
                  .text(format(slick.currentSlide + 1));

              $('.count-content .count-end')
                  .eq(index)
                  .text(format(slick.slideCount));
          }

          function repositionCarousel(index) {
              const $carousel = $(carouselIds[index]);

              if (!$carousel.hasClass('slick-initialized')) return;

              /*
               * Aguarda a aba ficar visível e o navegador
               * recalcular a largura do container.
               */
              setTimeout(function () {
                  $carousel.slick('setPosition');

                  /*
                   * Segundo recálculo para casos em que imagens,
                   * fontes ou estilos carregam posteriormente.
                   */
                  setTimeout(function () {
                      $carousel.slick('setPosition');
                      updateCount(index);
                  }, 300);
              }, 50);
          }

          function activeTab(index) {
              initVitrine.forEach(item => {
                  item.classList.remove('active');
              });

              rotationNames.forEach(item => {
                  item.classList.remove('active');
              });

              allLinks.forEach(item => {
                  item.classList.remove('active');
              });

              if (initVitrine[index]) {
                  initVitrine[index].classList.add('active');
              }

              if (rotationNames[index]) {
                  rotationNames[index].classList.add('active');
              }

              if (allLinks[index]) {
                  allLinks[index].classList.add('active');
              }

              $('.vitrine-arrows-1, .vitrine-arrows-2')
                  .removeClass('active');

              $(`.vitrine-arrows-${index + 1}`)
                  .addClass('active');

              repositionCarousel(index);
              updateCount(index);
          }

          carouselIds.forEach((id, index) => {
              const $carousel = $(id);

              if (!$carousel.hasClass('slick-initialized')) return;

              updateCount(index);

              $carousel
                  .off(`afterChange.rotation-${index}`)
                  .on(
                      `afterChange.rotation-${index}`,
                      function () {
                          updateCount(index);
                      }
                  );
          });

          rotationNames.forEach((itemMenu, index) => {
              itemMenu.addEventListener('click', event => {
                  event.preventDefault();
                  activeTab(index);
              });
          });

          activeTab(0);

          /*
           * Recalcula os carrosséis depois que a renderização
           * inicial da página estiver estabilizada.
           */
          setTimeout(function () {
              carouselIds.forEach(function (id, index) {
                  const $carousel = $(id);

                  if (
                      $carousel.hasClass('slick-initialized') &&
                      $carousel.is(':visible')
                  ) {
                      $carousel.slick('setPosition');
                      updateCount(index);
                  }
              });
          }, 500);

          /*
           * Recalcula quando a janela terminar de carregar
           * ou mudar de tamanho.
           */
          $(window)
              .off('load.rotation-vitrine resize.rotation-vitrine')
              .on(
                  'load.rotation-vitrine resize.rotation-vitrine',
                  function () {
                      setTimeout(function () {
                          carouselIds.forEach(function (id, index) {
                              const $carousel = $(id);

                              if (
                                  $carousel.hasClass('slick-initialized') &&
                                  $carousel.is(':visible')
                              ) {
                                  $carousel.slick('setPosition');
                                  updateCount(index);
                              }
                          });
                      }, 100);
                  }
              );
      }

      $(
          '#carrousel-product-list, ' +
          '#carrousel-product-list2, ' +
          '#carrousel-product-list3, ' +
          '#carrousel-product-list4'
      )
          .off('afterChange.rotation-lazy')
          .on('afterChange.rotation-lazy', function () {
              Blazy({
                  selector: '.lazy-img',
                  successClass: 'loaded-img',

                  success: function (image) {
                      setTimeout(function () {
                          var parent = image.previousSibling;

                          try {
                              parent.className = parent.className.replace(
                                  /\bproduct-item__image--loading\b/,
                                  ''
                              );
                          } catch (error) {
                              // Mantém o funcionamento caso o irmão não exista.
                          }
                      }, 200);
                  }
              });
          });
  });

    waitForElementToExist('.banner-categoria').then(element => {
        $('.banner-categoria__list').slick({
            arrows: false,
            infinite: true,
            autoplay: true,
            dots: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
            autoplaySpeed: 3000,
            responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5
                }
            }]
        });
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        $('.faixa-comunicado-content').slick({
            arrows: false,
            infinite: true,
            autoplay: true,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 557,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });

});